import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import {
  AUTH_TOKEN,
  BU_STORE_HEADER,
  BU_TENANT_HEADER,
  REFRESH_TOKEN,
  TENANT_CODE_HEADER,
  USER_INFO,
} from "store/auth/login/actionTypes";
// import { notification } from "antd";
import history from "../history";

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

// Config
const ENTRY_ROUTE = "/login";
const TOKEN_PAYLOAD_KEY = "authorization";
const X_TENANT = "X-Tenant";

// API Request interceptor
service.interceptors.request.use(
  config => {
    let jwtToken = "Bearer " + localStorage.getItem(REFRESH_TOKEN);
    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
    } else {
      history.push(ENTRY_ROUTE);
      window.location.reload();
    }
    return config;
  },
  error => {
    // Do something with request error here
    // notification.error({
    //   message: "Error",
    // });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    let notificationParam = {
      message: "",
    };
    // Remove token and redirect
    if (
      error.response.status === 400 ||
      // error.response.status === 403 ||
      error.response.status === 401
    ) {
      notificationParam.message = "Authentication Fail";
      notificationParam.description = "Please login again";
      localStorage.removeItem(AUTH_TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
      localStorage.removeItem("authUserdev");
      localStorage.removeItem("authUserprod");
      localStorage.removeItem(USER_INFO);
      localStorage.removeItem(TENANT_CODE_HEADER);
      localStorage.removeItem(BU_TENANT_HEADER);
      localStorage.removeItem(BU_STORE_HEADER);
      history.push(ENTRY_ROUTE);
      window.location.reload();
    }

    if (error.response.status === 404) {
      notificationParam.message = "Not Found";
    }

    if (error.response.status === 500) {
      notificationParam.message = "Internal Server Error";
    }

    if (error.response.status === 508) {
      notificationParam.message = "Time Out";
    }

    // notification.error(notificationParam);

    return Promise.reject(error);
  }
);

export default service;
